
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'AcuteLowerLimbIschemia',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/AcuteLowerLimbIschemia.vue